import { keyframes } from 'styled-components';

// Enhanced dice roll animation with 3D transforms
export const diceRollAnimation = keyframes`
  0% { 
    transform: translateZ(0) scale(1); 
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.15));
  }
  25% { 
    transform: translateZ(30px) scale(1.15); 
    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.25));
  }
  50% { 
    transform: translateZ(50px) scale(1.1); 
    filter: drop-shadow(0 16px 32px rgba(0, 0, 0, 0.3));
  }
  75% { 
    transform: translateZ(30px) scale(1.15); 
    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.25));
  }
  100% { 
    transform: translateZ(0) scale(1); 
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.15));
  }
`;

// Score highlight animation
export const scoreHighlightAnimation = keyframes`
  0% { 
    transform: scale(1);
    text-shadow: 0 0 0px rgba(255, 255, 255, 0);
  }
  50% { 
    transform: scale(1.2);
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8); 
  }
  100% { 
    transform: scale(1);
    text-shadow: 0 0 0px rgba(255, 255, 255, 0);
  }
`;

// Button pulse animation
export const buttonPulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(var(--theme-accent-rgb, 255, 193, 7), 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(var(--theme-accent-rgb, 255, 193, 7), 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(var(--theme-accent-rgb, 255, 193, 7), 0);
  }
`;

// Slide in animation
export const slideInAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Fade in animation
export const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

// Bounce animation for notifications and achievements
export const bounceAnimation = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

// Shake animation for error feedback
export const shakeAnimation = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(5px);
  }
`;

// Glowing border animation
export const glowingBorderAnimation = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(var(--theme-accent-rgb, 255, 193, 7), 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(var(--theme-accent-rgb, 255, 193, 7), 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(var(--theme-accent-rgb, 255, 193, 7), 0.5);
  }
`;

// Staggered entrance animation for lists (use with delay)
export const staggeredEntranceAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Rotating animation for loading indicators
export const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;